import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import styles from "../../assets/styles/whatsappButton/whatsapp.module.css";
import { useEffect, useMemo, useState } from "react";
import { fetchContactUs } from "../../utils/contactUsApi";

const WhatsAppButton = () => {
  const [number, setNumber] = useState("7417539900");

  useEffect(() => {
    fetchContactUs()
      .then((data) => {
        if (data?.whatsappNumber) setNumber(String(data.whatsappNumber));
      })
      .catch(() => {});
  }, []);

  const phoneNumber = useMemo(
    () => String(number || "").replace(/[^\d]/g, ""),
    [number]
  );

  const message =
    "Hello, I am interested in your Yoga Teacher Training courses. Could you please share more details?";
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappURL}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappFloat}
    >
     <FaWhatsapp className={styles.icon} />

    </a>
  );
};

export default WhatsAppButton;
